import { Component, OnInit, AfterViewChecked, AfterViewInit, Input, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { MatStepper } from '@angular/material';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-pagament',
  templateUrl: './pagament.component.html',
  styleUrls: ['./pagament.component.css']
})
export class PagamentComponent implements OnInit,  AfterViewChecked  {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  preinscripcio: Preinscripcio;
  stepPerformed = false;

  constructor(
      private dataService: DataService,
  ) {
    this.preinscripcio = dataService.preinscripcio;
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.preinscripcio = this.dataService.preinscripcio;
  }

  public async continua() {
    if (this.preinscripcio.estat === 64) {
      window.location.href = this.preinscripcio.urlCistellaPagamentInscripcio;
    } else {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pagament/pagament.component.ts